import React from 'react';
import "../../../assets/scss/loader-horizontal.scss";

export const MaterialLoader = ({ isShow }) => {
    return (isShow || typeof isShow === 'undefined') ?
        (<div className="load-bar">
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
        </div>) : '';
}

export const SignalLoader = ({ isShow }) => {
    return (isShow || typeof isShow === 'undefined') ? (<div className="signal"></div>) : '';
}

export const BarLoader = ({ isShow, isMultiColor }) => {
    if (isShow || typeof isShow === 'undefined') {
        return isMultiColor ?
            <div className="load-bar">
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
            </div>
            : <div className="loader"></div>;
    }
    return <></>;
}

export const HorizontalLoader = () =>
    <div className="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>;

export const NumberLoader = () =>
    <div className="number-loader">
        <span></span>
        <span></span>
        <span></span>
    </div>;